// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ci0H2"};